import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
};

const setData = (store, data) => {
  store.setState((state) => {
    state.modulo.timbrado_sftp.upsert.data = { ...data };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.timbrado_sftp.upsert = {
      ...state.modulo.timbrado_sftp.upsert,
      ...data,
    };
  });
};

const upsert = async (store, meta = {}, id) => {
  store.setState((state) => {
    state.modulo.timbrado_sftp.upsert.busy = true;
  });

  try {
    let response;

    if (!id) {
      response = await Http.post(`api/timbrado-tickets`, meta);
    } else {
      response = await Http.put(`api/timbrado-tickets/${id}`, {
        ...meta,
        hits: undefined,
      });
    }

    store.setState((state) => {
      state.modulo.timbrado_sftp.upsert.busy = false;
      state.modulo.timbrado_sftp.upsert.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.timbrado_sftp.upsert.busy = false;
      state.modulo.timbrado_sftp.upsert.error = error.data || error;
    });
  }
};

const resetError = (store) => (state) => {
  state.modulo.timbrado_sftp.upsert.error = undefined;
};

const reset = (store) => (state) => {
  state.modulo.timbrado_sftp.upsert = { ...initialState };
};

const actions = {
  setData,
  change,
  upsert,
  resetError,
  reset,
};

const TimbradoSftpUpsertStore = {
  state: () => initialState,
  actions,
};

export default TimbradoSftpUpsertStore;
